import {createSelector} from 'reselect';
import {CONTAINER_TYPES, SERVICE_TYPES} from '../../constants/entitlements';
import {ProjectStatuses} from '../../constants/projects';

export const getDocsCurrentProject = createSelector(
  state => state.currentProject,
  ({docsCurrentProject}) => docsCurrentProject
);

export const getCurrentProject = createSelector(
  state => state.currentProject,
  ({currentProject}) => currentProject
);

export const getCurrentProjectScope = createSelector(
  getCurrentProject,
  ({projectScope}) => projectScope
);

export const getProjectName = createSelector(
  getCurrentProject,
  ({name}) => name || ''
);

export const isProjectSetupInProgress = createSelector(
  getDocsCurrentProject,
  project => project && project.status !== ProjectStatuses.ACTIVE
);

export const getChecklistContainerId = createSelector(
  getCurrentProject,
  ({containers}) => containers?.find(el => el.type === CONTAINER_TYPES.CHECKLIST)?.id
);

export const isFieldManagementActive = createSelector(
  getCurrentProject,
  getChecklistContainerId,
  ({services}, checklistContainerId) =>
    !!(checklistContainerId && services?.find(el => el.type === SERVICE_TYPES.FIELD_MANAGEMENT))
);
